<template>
  <div class="wrapper">
    <Headers ref="headers" />
    <div class="mainPage1">
      <section class="user-setting">
        <div class="container">
          <div class="container__elem container__elem--12">
            <h1 class="playlist-setting__title">Настройка плейлиста Аккаунт</h1>
            <div class="playlist-setting__sections-wrap">
              <p class="playlist-setting__sections-descr">
                Выберите категории
              </p>
              <div class="playlist-setting__sections">
                <div class="playlist-setting__sections-content">
                  <div class="playlist-setting__sections-list">
                    <div class="playlist-setting__sections-inner playlist-setting__sections-inner--allCategories"
                      @click="toggleAllCategories()">
                      <div class="playlist-setting__sections-select--allCategories"
                        :class="getAllCategoriesSelectClass()">
                        .
                      </div>
                      <p class="playlist-setting__sections-item--allCategories">
                        Выбрать все
                      </p>
                    </div>
                    <div class="playlist-setting__sections-inner" v-for="category in categories" :key="category.id"
                      :class="{ active: selectedCategory === category }" @click="selectCategory(category)">
                      <div class="playlist-setting__sections-select" :class="getCategorySelectClass(category)"
                        @click="toggleSelection">
                        .
                      </div>
                      <p class="playlist-setting__sections-item">
                        {{ category.name }}
                        <span v-if="category.subcategoryCount > 0">{{ category.subcategoryCount }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="playlist-setting__sections-choices">
                    <div class="playlist-setting__sections-back">
                      <i>
                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.33337 1L1.33337 5L5.33337 9" stroke="#4BB85A" stroke-linecap="square" />
                        </svg>

                      </i>
                      <p>
                        Вернуться к категориям
                      </p>
                    </div>
                    <div class="playlist-setting__sections-choice" :class="{ active: selectedCategory }">
                      <p class="playlist-setting__sections-title">{{ selectedCategory ? selectedCategory.title : '' }}
                      </p>
                      <div class="playlist-setting__sections-inputs">
                        <div v-for="subcategory in selectedCategory ? selectedCategory.categories : []"
                          :key="subcategory.id"
                          :class="['playlist-setting__sections-checkbox', { checked: selectedSubcategories[selectedCategory.id]?.includes(subcategory.id) }]">
                          <input type="checkbox" :id="`checkbox${subcategory.id}`" @click="clickOnSubcategories()"
                            :value="subcategory.id" v-model="selectedSubcategories[selectedCategory.id]" />
                          <label :for="`checkbox${subcategory.id}`">
                            {{ subcategory.name }} <span v-if="subcategory.eventCount > 0">{{ subcategory.eventCount
                              }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button @click="sectionsModalConfirm()" class="playlist-setting__sections-btn">Сохранить</button>
              <div v-if="message" :class="['user-setting__message', message.type]">{{ message.text }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footers />
  </div>
</template>

<script>

import axios from 'axios'
import Headers from '@/components/Headers.vue'
import Footers from '@/components/Footers.vue'
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';



export default {
  name: 'PlaylistSettingView',
  components: {
    Headers,
    Footers
  },
  data() {
    return {
      categories: [],
      selectedCategory: null,
      selectedSubcategories: {},
      oldSelectedSubcategories: {},
      sectionsSelectStates: {},
      message: null, // Сообщение о результате
    };
  },
  methods: {
    getAllCategoriesSelectClass() {
      const totalCategories = this.categories.length;
      let selectedCategoriesCount = 0;

      // Для каждой категории проверяем, выбраны ли все её подкатегории
      this.categories.forEach(category => {
        const subcategoryIds = category.categories.map(subcategory => subcategory.id);
        const selectedSubcategoriesIds = this.selectedSubcategories[category.id] || [];

        // Если все подкатегории выбраны
        if (subcategoryIds.length === selectedSubcategoriesIds.length) {
          selectedCategoriesCount++;
        }
      });

      if (selectedCategoriesCount === totalCategories) {
        return 'all'; // Все категории выбраны
      } else if (selectedCategoriesCount > 0) {
        return 'some'; // Некоторые категории выбраны
      }
      return ''; // Нет выбранных категорий
    },
    getCategorySelectClass(category) {
      const subcategoryIds = category.categories.map(subcategory => subcategory.id);
      const selectedSubcategoriesIds = this.selectedSubcategories[category.id] || [];

      if (subcategoryIds.length === selectedSubcategoriesIds.length) {
        return 'all'; // Все подкатегории выбраны
      } else if (selectedSubcategoriesIds.length > 0) {
        return 'some'; // Некоторые подкатегории выбраны
      }
      return ''; // Нет выбранных подкатегорий
    },
    async fetchUserCategories() {
      try {
        const response = await axios.get('/api/pis/v1/playlists/user/categories', {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        // Обновляем selectedSubcategories только теми подкатегориями, id которых присутствуют в response.data.categories
        this.categories.forEach(category => {
          // Отфильтровываем подкатегории по id, которые есть в response.data.categories
          const filteredSubcategories = category.categories.filter(subcategory =>
            response.data.categories.includes(subcategory.id)
          );

          // Заполняем selectedSubcategories для каждой категории
          this.selectedSubcategories[category.id] = filteredSubcategories.map(subcategory => subcategory.id);
        });



        // Вызываем функцию обновления
        this.refreshAllCategories();

      } catch (error) {
        console.error('Ошибка при загрузке категорий пользователя:', error);
      }
    },
    async fetchCategories() {
      try {
        const response = await fetch('/api/pis/v1/sections?sort=true', {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1'
          }
        });

        const data = await response.json();

        // Инициализация всех подкатегорий по умолчанию
        data.forEach(category => {
          this.selectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
        });
        this.oldSelectedSubcategories = this.selectedSubcategories;
        this.categories = data;
        await this.fetchUserCategories();
        setTimeout(() => {
          document.querySelector('.mainPage1').classList.remove('load');
          this.createdBefore();
        }, 100);
      } catch (error) {
        console.error('Ошибка при загрузке категорий:', error);
      }
    },
    createdBefore() {
      let sectionContent = document.querySelector('.playlist-setting__sections-content');
      let sectionBack = document.querySelector('.playlist-setting__sections-back');
      let sectionSelect = document.querySelectorAll('.playlist-setting__sections-select');
      sectionSelect.forEach(item => {
        item.addEventListener('click', () => {
          if (item.classList.contains('all')) {
            item.classList.remove('all');
          } else if (item.classList.contains('some')) {
            item.classList.remove('some');
            item.classList.add('all');
          } else {
            item.classList.add('all');
          }
          setTimeout(() => {
            this.toggleSelection()
          }, 10);
        });
      });
      setTimeout(() => {
        const firstCategory = document.querySelector('.playlist-setting__sections-item');
        const firstChoice = document.querySelector('.playlist-setting__sections-choice');

        if (firstCategory && firstChoice) {
          // Присваиваем класс active выбранным элементам
          firstCategory.classList.add('active');
          firstChoice.classList.add('active');

          // Имитируем клик по первой категории
          this.selectCategory(this.categories[0]);
        }
      }, 10);
      if (window.innerWidth < 639) {
        setTimeout(() => {
          let sectionItem = document.querySelectorAll('.playlist-setting__sections-item');
          sectionItem.forEach(function (itemOther) {
            itemOther.classList.remove('active');
            itemOther.addEventListener('click', () => {
              sectionContent.classList.add('active');
            });
          });
        }, 1000);
        sectionBack.addEventListener('click', function () {
          sectionContent.classList.remove('active');
        });
      }
    },
    toggleAllCategories() {
      let btn = document.querySelector('.playlist-setting__sections-select--allCategories');

      if (btn.classList.contains('all')) {
        for (let category of this.categories) {
          this.selectedSubcategories[category.id] = [];
        }
        document.querySelectorAll('.playlist-setting__sections-select').forEach(element => {
          element.classList.remove('all')
          element.classList.remove('some')
        });
      } else {
        this.categories.forEach(category => {
          this.selectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
        });
        document.querySelectorAll('.playlist-setting__sections-select').forEach(element => {
          element.classList.add('all')
          element.classList.remove('some')
        });
      }
      this.refreshAllCategories()
    },
    refreshAllCategories() {
      let flag1 = 0;
      let flag2 = 1;  // Предположим, что все элементы не имеют ни класса 'all', ни класса 'some'

      let btn = document.querySelector('.playlist-setting__sections-select--allCategories');

      document.querySelectorAll('.playlist-setting__sections-select').forEach(element => {
        if (!element.classList.contains('all')) {
          flag1 = 1;
        }
        if (element.classList.contains('all') || element.classList.contains('some')) {
          flag2 = 0;  // Если хотя бы один элемент имеет класс 'all' или 'some', то flag2 будет 0
        }
      });

      if (flag1 == 0 && flag2 == 0) {
        btn.classList.add('all')
        btn.classList.remove('some')
      } else if (flag1 == 1 && flag2 == 0) {
        btn.classList.add('some')
        btn.classList.remove('all')
      } else if (flag1 == 1 && flag2 == 1) {
        btn.classList.remove('all')
        btn.classList.remove('some')
      }
    },
    selectCategory(category) {
      // Проверяем, есть ли уже сохраненные подкатегории для текущей категории
      if (!this.selectedSubcategories[category.id]) {
        // Если нет, инициализируем массив подкатегорий
        this.selectedSubcategories[category.id] = [];
      }

      this.selectedCategory = category;

    },
    resetAllSubcategories() {
      if (this.selectedCategory) {
        this.selectedSubcategories[this.selectedCategory.id] = [];
      }
    },
    clickOnSubcategories() {
      let currentElement = document.querySelector('.playlist-setting__sections-inner.active');
      let selectElement = currentElement.querySelector('.playlist-setting__sections-select');

      setTimeout(() => {
        if (this.selectedCategory && this.selectedCategory.categories.length > 0) {
          // Проверка, существует ли массив выбранных подкатегорий для текущей категории
          let selectedSubcategories = this.selectedSubcategories[this.selectedCategory.id] || [];

          // Проверка, если все подкатегории выбраны
          let allSubcategoriesSelected = this.selectedCategory.categories.every(subcategory =>
            Array.isArray(selectedSubcategories) && selectedSubcategories.includes(subcategory.id)
          );

          // Удаление всех классов, кроме .playlist-setting__sections-select
          selectElement.className = 'playlist-setting__sections-select';

          // Установка класса для playlist-setting__sections-select в зависимости от результата проверки
          if (allSubcategoriesSelected) {
            selectElement.classList.add('all');
          } else if (selectedSubcategories.length > 0) {
            // Если есть выбранные подкатегории, но не все
            selectElement.classList.add('some');
          }
        } else {
          // Если нет выбранных подкатегорий, удаляем все классы, кроме .playlist-setting__sections-select
          selectElement.className = 'playlist-setting__sections-select';
        }

        this.refreshAllCategories();
      }, 10);
    },
    selectAllSubcategories() {
      if (this.selectedCategory) {
        this.selectedSubcategories[this.selectedCategory.id] = this.selectedCategory.categories.map(subcategory => subcategory.id);;
      }
    },
    async sectionsModalConfirm() {
      // Объединяем все массивы из this.selectedSubcategories в один массив
      const selectedCategories = Object.values(this.selectedSubcategories).flat();

      try {
        const response = await axios.post('/api/pis/v1/playlists/user/categories', {
          categories: selectedCategories,
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        // Обработка успешного ответа
        this.message = {
          text: 'Категории успешно сохранены!',
          type: 'success',
        };
        setTimeout(() => {
          this.message = null;
        }, 5000);

      } catch (error) {
        console.error('Ошибка запроса:', error);
        // Обработка ошибки
        this.message = {
          text: 'Ошибка при сохранении категорий. Попробуйте еще раз.',
          type: 'error',
        };
      }
    },
    toggleSelection() {
      setTimeout(() => {
        let item = document.querySelector(".playlist-setting__sections-inner.active > .playlist-setting__sections-select")
        if (item.classList.contains('all')) {
          item.classList.remove('all');
          this.resetAllSubcategories();
          this.refreshAllCategories();
        } else if (item.classList.contains('some')) {
          item.classList.remove('some');
          item.classList.add('all');
          this.selectAllSubcategories();
          this.refreshAllCategories();
        } else {
          item.classList.add('all');
          this.selectAllSubcategories();
          this.refreshAllCategories();
        }
      }, 100);
    },
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));
    if (!userInfo) {
      this.$router.push({ path: '/login' });
    }
    this.fetchCategories();

  }

};
</script>
<style>
.playlist-setting__message {
  margin-top: 16px;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
}

.playlist-setting__message.success {
  color: #4caf50;
  /* Зеленый для успешного сообщения */
  background-color: #dff0d8;
  /* Светлый зеленый фон */
}

.playlist-setting__message.error {
  color: #f44336;
  /* Красный для сообщения об ошибке */
  background-color: #f8d7da;
  /* Светлый красный фон */
}
</style>